export default {
  AUTH_STRATEGY_ENFORCEMENT_DONE: "authStrategyEnforcementDone",
  AUTH_TOKEN_REFRESH_DONE: "authTokenRefreshDone",
  USER_GROUP_MANAGEMENT_USER_GROUP_FORM_SUBMITTED: "userGroupManagementUserGroupFormSubmitted",
  USER_LIST_ERROR_DIALOG_CALLED: "userListErrorDialogCalled",
  USER_LIST_SUCCESS_DIALOG_CALLED: "userListSuccessDialogCalled",
  USER_LIST_GENERIC_DIALOG_ACTION_DONE: "userListGenericDialogActionDone",
};
